var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage,"loader":"dots","background-color":_vm.backgroundColor,"color":_vm.color,"height":_vm.height,"width":_vm.width,"opacity":_vm.opacity},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('div',[_c('NavbarContainer')],1),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }